import React from "react"
import PropTypes from "prop-types"

import OldLayout from "./OldLayout"
import ModernLayout from "../ModernLayout"

const TypeLayout = ({ type, ...props }) => {
  const types = {
    v0: OldLayout,
    v1: ModernLayout
  }

  const ComponentLayout = types[type] || OldLayout

  return <ComponentLayout {...props} />
}

TypeLayout.propTypes = {
  type: PropTypes.string
}

export default TypeLayout



// WEBPACK FOOTER //
// ./src/components/Layout/index.js